module.exports = __webpack_public_path__ + "img/iPhone12.47969cb1.png";